package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable

@Serializable
data class InitialInspection(
    val id: Int,
    val appointment_id: Int?,
    val created_at: String? = null,
    val updated_at: String? = null,
    val inspection_type_id: Int?,
    val inspection_option_id: Int?
)
